import React, { FC, ReactElement } from 'react';
import {GUTTER} from "../../../constants";
import {Col, Row} from "antd";
import {SectionPerformanceCard} from "../components/Generic/SectionPerformanceCard";
import {
    AttemptPerformanceDataTableCard
} from "../components/TextFeedback/AttemptPerformanceDataTableCard";
import {FeedbackRowProps} from "./types";

export const TranscriptFeedbackRow: FC<FeedbackRowProps> = ({attemptId, activityId, style}): ReactElement => (
    <Row gutter={GUTTER} style={style}>
        <Col span={24}>
            {attemptId ? <AttemptPerformanceDataTableCard attemptId={attemptId}/> :
                <SectionPerformanceCard type='conversation' activityId={activityId}/>}
        </Col>
    </Row>
);
